import type { UpSellPlacement } from "../../upSell/placement";

/** Emit-side names for flights up-sell raw events. */
export enum UpSellRawEventName {
  ViewedHotelUpSell = "ViewedHotelUpSell",
  TappedHotelUpSell = "TappedHotelUpSell",
  ViewedHotelUpSellModal = "ViewedHotelUpSellModal",
  TappedHotelUpSellModalCta = "TappedHotelUpSellModalCta",
  HotelUpSellFailed = "HotelUpSellFailed",
}

/** The user's decision in the up-sell dialog. */
export enum UpSellChoice {
  add_hotel = "add_hotel",
  no_thanks = "no_thanks",
  dismissed = "dismissed",
}

/** Why entering the packages funnel from the up-sell did not work. */
export enum UpSellFailureReason {
  no_hotels_available = "no_hotels_available",
  no_destination_coordinates = "no_destination_coordinates",
  missing_search_params = "missing_search_params",
  request_error = "request_error",
}

// Property shapes must be `type` aliases, not `interface` — the tracking `AEvent`
// constraint needs `Record<string, unknown>`, which interfaces don't satisfy.

/** On every up-sell event. */
export type UpSellCommonProperties = {
  up_sell_placement?: UpSellPlacement;
  rbc_price_tab?: "fixed" | "flex";
};

export type ViewedHotelUpSellProperties = UpSellCommonProperties & {
  trip_type?: string;
  origin?: string;
  destination?: string;
  departure_date?: string;
  return_date?: string;
  los?: number;
  adults_count?: number;
  children_count?: number;
  infants_count?: number;
};

export type TappedHotelUpSellModalCtaProperties = UpSellCommonProperties & {
  choice: UpSellChoice;
};

export type HotelUpSellFailedProperties = UpSellCommonProperties & {
  failure_reason: UpSellFailureReason;
  destination?: string;
  departure_date?: string;
  return_date?: string;
};

export interface ViewedHotelUpSellRawEvent {
  name: UpSellRawEventName.ViewedHotelUpSell;
  properties: ViewedHotelUpSellProperties;
}

export interface TappedHotelUpSellRawEvent {
  name: UpSellRawEventName.TappedHotelUpSell;
  properties: UpSellCommonProperties;
}

export interface ViewedHotelUpSellModalRawEvent {
  name: UpSellRawEventName.ViewedHotelUpSellModal;
  properties: UpSellCommonProperties;
}

export interface TappedHotelUpSellModalCtaRawEvent {
  name: UpSellRawEventName.TappedHotelUpSellModalCta;
  properties: TappedHotelUpSellModalCtaProperties;
}

export interface HotelUpSellFailedRawEvent {
  name: UpSellRawEventName.HotelUpSellFailed;
  properties: HotelUpSellFailedProperties;
}

export type UpSellRawEvent =
  | ViewedHotelUpSellRawEvent
  | TappedHotelUpSellRawEvent
  | ViewedHotelUpSellModalRawEvent
  | TappedHotelUpSellModalCtaRawEvent
  | HotelUpSellFailedRawEvent;
